import constants from "../../core/constants";
import moment from "moment";

class Controller {
  constructor($injector, $stateParams) {
    "ngInject";
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.travelRequest = $injector.get("TravelRequest");
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }
  $onInit() {
    this.travelRequest.get(this.$stateParams.id).$promise.then((response) => {
      this.req = response;
      this.req.travel_date = moment(this.req.travel_date).format(
        constants.dateFormat
      );
      if (this.req.return_date) {
        this.req.return_date = moment(this.req.return_date).format(
          constants.dateFormat
        );
      }
    });
  }
  resolveRequest() {
    this.travelRequest
      .resolve(this.$stateParams.id)
      .$promise.then((response) => {
        this.req = response;
        this.Events.emit(this.showNotificationEvent, {
          message: "Travel Request resolved succesfully",
        });
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/travelRequest/travelRequest.controller.js